<script>
	import { Col, Row } from "@sveltestrap/sveltestrap";

	export let vqp;
	export let isInvestigating = false;
	export let caseDetails = {};
</script>

<Row class="mb-4">
	<Col xs={2}>
		<Row>
			<Col>
				<label for="vqp" class="d-block">
					<span>
						VQP<span class="text-danger">*</span>
					</span>
				</label>
			</Col>
		</Row>
		<Row>
			{#each [0, 1, 2] as vqpValue, i}
				<Col>
					<input
						type="radio"
						name="vqp"
						id={"vqp-" + i}
						value={vqpValue}
						bind:group={$vqp.value}
						disabled={isInvestigating ||
							caseDetails.status === "Investigating"}
						aria-label="VQP {vqpValue}"
					/>
					<span>{vqpValue}</span>
				</Col>
			{/each}
		</Row>
	</Col>
</Row>
